import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import ScrollMenu from "../menus/ScrollMenu";
import { Box } from "@mui/system";
import { useMediaQuery } from "@mui/material";

export default function RiskwiseMenu(){
    const [isFixed, setIsFixed] = useState(false);
    const [initialBoxPosition, setInitialBoxPosition] = useState(0);
    const boxRef = useRef(null);

    const mobile=useMediaQuery(theme=>theme.breakpoints.down('md'));

    const handleScroll = () => {
        const boxElement = boxRef.current;  

        if (boxElement) {
            const boxPosition = boxRef.current.getBoundingClientRect().top;
            const adminBarHeight = 100;

            if (isFixed && window.scrollY - 450 <= initialBoxPosition) {
                setIsFixed(false);
            } else if (!isFixed && boxPosition <= adminBarHeight) {
                setIsFixed(true);
            }
        }
    };

    useEffect(()=>{
        const handleInitialPosition = () => {
            const boxElement = boxRef.current;
            if (boxElement) {
                const boxPosition = boxElement.getBoundingClientRect().top;
                setInitialBoxPosition(boxPosition);
            }
        }

        handleInitialPosition();
        window.addEventListener('scroll', handleScroll);
        return ()=>{
            window.removeEventListener('scroll', handleScroll);
        }

    },[isFixed, initialBoxPosition]);


    const menuData = [
        {
            // Menu to scroll to the Benefits section
            url:'benefits',
            title:'Benefits',
            id: 1,
        },
        // Modules
        {
            url:'modules',
            title:'Modules',
            id: 2,
        },
        // Key Functionality
        {
            url:'functions',
            title:'Key Features',
            id: 3,
        },
        //Testimonials
        {
            url:'testimonials',
            title:'Testimonials',
            id: 5,
        },
        //Security & Integrations
        {
            url:'security-integrations',
            title:'Security',
            id: 5,
        },
    ];
    
    return(
        <>
            <Box
                sx={{
                    height: isFixed ? '60px' : '0px',
                }}
            />
            <Box
                ref={boxRef}
                sx={{
                    width: '100%',
                    position: mobile ? 'relative' : (isFixed ? 'fixed' : 'relative'),
                    top: mobile ? 'auto' : isFixed ? '100px' : 'auto',
                    zIndex: 9,
                }}
            >
                <ScrollMenu
                    items={menuData}
                    loading={!menuData}
                />
            </Box>
        </>
    );
}